<script>
import { ref, onMounted, getCurrentInstance } from 'vue'
import axios from 'axios'
import CheckIcon from '@/components/icons/CheckIcon.vue'
import CrossIcon from '@/components/icons/CrossIcon.vue'

export default {
  components: {
    CheckIcon, CrossIcon,
  },
  name: 'PpcAuthTable',
  props: {},
  methods: {
    routeToPpcDetails(ppcAuth) {
      this.$router.push({ name: 'ppcAuthDetail', params: { id: ppcAuth.id } })
    },
  },
  setup() {
    const ppcAuths = ref([])
    const loading = ref(true)
    const apiError = ref(null)
    const oktaAuth = getCurrentInstance().appContext.app.config.globalProperties.$auth

    function fetchData() {
      const API_URL = `${process.env.VUE_APP_API_DOMAIN}/ppc_creds/`
      axios.defaults.headers.common.Authorization = `Bearer ${oktaAuth.getAccessToken()}`
      axios
        .get(API_URL)
        .then((response) => {
          ppcAuths.value = response.data
        })
        .finally(() => {
          loading.value = false
        })
    }

    onMounted(() => {
      fetchData()
    })

    return {
      ppcAuths,
      loading,
      apiError,
      fetchData,
    }
  },
}
</script>
<template>
  <div class="flex flex-col">
    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block py-2 min-w-full sm:px-6 lg:px-8">
        <div class="overflow-hidden shadow-md sm:rounded-lg">
          <table class="min-w-full">
            <thead class="bg-gray-100 dark:bg-gray-700">
              <tr class="border-b1">
                <th
                  scope="col"
                  class="
                    py-3
                    px-6
                    text-xs
                    font-medium
                    tracking-wider
                    text-left text-gray-700
                    dark:text-gray-400
                  "
                >
                  Name
                </th>
                <th
                  scope="col"
                  class="
                    py-3
                    px-6
                    text-xs
                    font-medium
                    tracking-wider
                    text-left text-gray-700
                    dark:text-gray-400
                  "
                >
                  PPC Token
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="ppcAuth in ppcAuths"
                :key="ppcAuth.id"
                class="hover:bg-slate-50"
              >
                <td
                  class="
                    py-4
                    px-6
                    text-sm text-gray-500
                    whitespace-nowrap
                    dark:text-gray-400
                  "
                >
                  <button @click="routeToPpcDetails(ppcAuth)">
                    <span class="underline">{{ ppcAuth.name }}</span>
                  </button>
                </td>
                <td
                  class="
                    py-4
                    px-6
                    text-sm text-gray-500
                    whitespace-nowrap
                    dark:text-gray-400
                  "
                >
                  <check-icon v-if="!!ppcAuth.has_ppc_token"/>
                  <cross-icon v-if="!ppcAuth.has_ppc_token"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
</style>
